import { ProductName, LineOfBusiness } from '@core/constants';
import { ProductConfiguration } from '@shared/models/product-options.model';

export const productAccessConfig: ProductConfiguration[] = [
  {
    option: {
      value: ProductName.HH,
      label: 'Home Health Resource Router',
    },
    access: [
      'HHServiceLineRule.Read',
      'HHServiceLineMetric.Read',
      'HHServiceLineQueue.Read',
    ],
  },
  {
    option: {
      value: ProductName.PAC_COM,
      label: 'PAC Commercial Resource Router',
      lineOfBusiness: LineOfBusiness.Commercial,
    },
    access: [
      'PACCOMServiceLineRule.Read',
      'PACCOMServiceLineMetric.Read',
      'PACCOMServiceLineQueue.Read',
    ],
  },
  {
    option: {
      value: ProductName.PAC_MA,
      label: 'PAC MA Resource Router',
      lineOfBusiness: LineOfBusiness.MedicareAdvantage,
    },
    access: [
      'PACMAServiceLineRule.Read',
      'PACMAServiceLineMetric.Read',
      'PACMAServiceLineQueue.Read',
    ],
  },
  {
    option: {
      value: ProductName.DMEPOS_MA,
      label: 'DMEPOS MA Resource Router',
      lineOfBusiness: LineOfBusiness.MedicareAdvantage,
    },
    access: [
      'DMEPOSAuthorizationCaseRule.Read',
      'DMEPOSAuthorizationCaseMetric.Read',
      'DMEPOSAuthorizationCaseQueue.Read',
    ],
  },
  {
    option: {
      value: ProductName.DMEPOS_MCD,
      label: 'DMEPOS Medicaid Resource Router',
      lineOfBusiness: LineOfBusiness.Medicaid,
    },
    access: [
      'DMEPOSMedicaidRule.Read',
      'DMEPOSMedicaidMetric.Read',
      'DMEPOSMedicaidQueue.Read',
    ],
    featureToggle: 'DMEPOSMedicaid',
  },
];
